// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c0c57cad","239":"6462cba4","455":"83e5f07e"}[chunkId] + ".chunk.js";
};